import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 300;
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        margin: '0',
        overflow: 'auto',
    },
    root1: {
        display: 'flex',
        width: '100%',
        height: '100%',
        margin: '0',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        backgroundColor: '#31333f',
    },
    headermain: {
        display: 'block',
    },
    headerleft: {
        float: 'left',
        paddingTop: '7px',
    },
    headerright: {
        float: 'right',
        paddingTop: '21px',
        fontSize: '13px',
        display: 'flex',
        justifyContent: 'space-evenly',
    },
    headericon: {
        fontSize: '18px',
    },
    verticalline: {
        borderLeft: '1px solid hsl(0deg 0% 49%)',
        height: '30px',
        margin: '0 17px',
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        overflowY: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    nested: {
        paddingLeft: '106px',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    iconmainlist: {
        fontSize: '19px',
        color: '#808080',
        textAlign: 'center',
    },
    iconlist: {
        display: 'inline',
        color: '#808080',
        minWidth: '45px',
    },
    listitemtext: {
        textAlign: 'left',
        marginLeft: '10px',
    },
    gettext: {
        fontSize: '13px',
    },
    footer: {
        bottom: '0px',
        position: 'fixed',
        backgroundColor: '#31333f',
        width: '100%',
        height: '60px',
        zIndex: '1201',
        textAlign: 'center',
        color: 'white',
    },
    footertitle: {
        fontSize: '0.9rem',
        paddingTop: '15px',
    },
    clientlogo: {
        maxWidth: '100%',
        maxHeight: '100%',
    },
    headerImg: {
        padding: '12px',
    },
    divider: {
        width: '87%',
    },
    table: {
        // minWidth: 650,
        // border: '1px solid black',
    },
    button: {
        display: 'inline-block',
        marginRight: '10px',
        float: 'right',
    },
    h2: {
        display: 'inline-block',
        float: 'left',
    },
    dashboardmaindiv: {
        marginTop: '37px',
    },
    imcTable: {
        boxShadow: '0px 0px 5px #eaeaea !important',
        background: '#ffffff',
        borderRadius: '6px',
        overflow: 'hidden',
    },
    imcHeading: {
        padding: '10px 16px',
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '17px !important',
            fontWeight: '500 !important',
            color: '#4e4e4e !important',
        },
    },

    tablemaincontainer: {
        maxHeight: 250,
        borderRadius: '0',
    },
    imctableheading: {
        fontWeight: '700',
        fontFamily: 'Rubik',
        color: '#535353;',
        backgroundColor: '#f6f6f6',
        fontSize: '13px',
    },
    imctableBody: {
        fontWeight: '500',
        fontFamily: 'Rubik',
        color: '#747474',
        fontSize: '12px',
    },

    '@global': {
        '*::-webkit-scrollbar': {
            width: '0.4em',
        },
        '*::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgb(0 0 0 / 65%)',
            // outline: '4px solid #f8961d',
        },
    },
    dashboarditecdiv: {
        padding: '40px',
        marginLeft: '20%',
        marginRight: '20%',
    },
    dashboardcorediv: {
        padding: '40px',
        marginLeft: '20%',
        marginRight: '20%',
    },
}));

export default useStyles;
